import { useContext, useEffect } from "react";
import { switchh } from "../../context/switch";
import { collection } from "../../context/collect";
import { update } from "../indexDB/indexDBStora";
import { config } from "../../context/config";
import validTables from '../../data/validTables.json';
import { useTranslation } from "react-i18next";
import { useRestore } from "../../funcs/restore";

export default function Rules () {
    const { t } = useTranslation();
    const { restore, restoredProducts } = useRestore();
    const { setLoadingProcess, setEnableSendResetCode } = useContext(switchh);
    const { setCbusinessRules, cBusniessRules } = useContext(collection);
    const { tablesAreCreates } = useContext(config);

    const handleTimeEmpWorkChange = (parent,section, field, value) => {
        setCbusinessRules((prev) => ({
            ...prev,
            [parent]: {
            ...prev[parent],
            [section]: {
                ...prev[parent][section],
                [field]: Number(value)
            }
        }
    }));
    };

    useEffect(() => {
        console.log(restoredProducts);
    }, [restoredProducts])

    const handleWorkRules = async () => {
        setLoadingProcess(true)
        await update("settings", cBusniessRules);
        setLoadingProcess(false)
        return alert("تم تحديث وقت العمل قواعد العمل الخاصة بكم");
    }
    
    return (
        <div className="section rules">
            <h3>{t("label:settings.timeManagementAttendance.title")}</h3>
            <small>{t("label:settings.timeManagementAttendance.desc")}</small>
                <h4>{t("label:settings.timeManagementAttendance.body.deduction.title")}</h4>
                <div className="parent flex">
                    <div className="child">
                        <label>{t("label:settings.timeManagementAttendance.time")}</label>
                        <input
                            type="number"
                            className="line"
                            min={1}
                            placeholder="by min"
                            value={cBusniessRules.timeEmpWork.delay.min}
                            onChange={(e) => handleTimeEmpWorkChange("timeEmpWork", "delay", "min", e.target.value)}
                        />
                    </div>
                    <div className="child">
                        <label>{t("label:settings.timeManagementAttendance.body.deduction.body.deduction")}</label>
                        <input
                            type="number"
                            className="line"
                            min={1}
                            placeholder="deduction"
                            value={cBusniessRules.timeEmpWork.delay.deduction}
                            onChange={(e) => handleTimeEmpWorkChange("timeEmpWork", "delay", "deduction", e.target.value)}
                        />
                </div>
                <h4>{t("label:settings.timeManagementAttendance.body.bouns.title")}</h4>
                <div className="parent flex">
                    <div className="child">
                            <label>{t("label:settings.timeManagementAttendance.time")}</label>
                            <input type="number" 
                            onChange={(e) => handleTimeEmpWorkChange("timeEmpWork", "early", "min", e.target.value)}
                            value={cBusniessRules.timeEmpWork.early.min} className="line" min={1} placeholder="by min" />
                    </div>
                    <div className="child">
                        <label>{t("label:settings.timeManagementAttendance.body.bouns.body.bouns")}</label>
                        <input 
                        onChange={(e) => handleTimeEmpWorkChange("timeEmpWork", "early", "bouns", e.target.value)}
                        value={cBusniessRules.timeEmpWork.early.bouns} type="number" className="line" min={1} placeholder="deductuin" />
                    </div>
                </div>
            <h3>{t("label:settings.timeManagementDelivery.title")}</h3>
            <small>{t("label:settings.timeManagementDelivery.desc")}</small>

                <div className="parent flex flex-space-ar">
                    <div className="child child-nano">
                        <label>{t("label:settings.timeManagementDelivery.body.normal")}</label>
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "normal", "min", e.target.value)} value={cBusniessRules.monitorPilots.normal.min} type="number" className="line" min={1} max={60} placeholder="by mins" />
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "normal", "hours", e.target.value)} value={cBusniessRules.monitorPilots.normal.hours} type="number" className="line" min={1} max={12} placeholder="by hours" />
                    </div>
                    <div className="child child-nano">
                        <label>{t("label:settings.timeManagementDelivery.body.warning")}</label>
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "warning", "min", e.target.value)} value={cBusniessRules.monitorPilots.warning.min} type="number" className="line" min={1} max={60} placeholder="by mins" />
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "warning", "hours", e.target.value)} value={cBusniessRules.monitorPilots.warning.hours} type="number" className="line" min={1} max={12} placeholder="by hours" />
                    </div>
                    <div className="child child-nano">
                        <label>{t("label:settings.timeManagementDelivery.body.late")}</label>
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "danger", "min", e.target.value)} value={cBusniessRules.monitorPilots.danger.min} type="number" className="line" min={1} max={60} placeholder="by mins" />
                        <input onChange={(e) => handleTimeEmpWorkChange("monitorPilots", "danger", "hours", e.target.value)} value={cBusniessRules.monitorPilots.danger.hours} type="number" className="line" min={1} max={12} placeholder="by hours" />
                    </div>
                </div>
                </div>
            <div className="btn">
                <button className="normal-bg" onClick={() => handleWorkRules()}>{t("action:save")}</button>
            </div>
            <div className="flex flex-align-item-center digital">
                <table className="table-page-50 center">
                    <thead>
                        <tr>
                            <th>##</th>
                            <th>tables (V100.0)</th>
                            <th>status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {validTables.map((e,i) => {
                            const status = tablesAreCreates.includes(e);
                            return (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{e}</td>
                                    <td className={status ? "success" : "error"}>{status ? "true" : "false"}</td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </table>
                <div className="summary-tables">
                    <p>tables are created ( {tablesAreCreates.length ? tablesAreCreates.length : '0'} / {validTables.length} )</p>
                    <p>
                        status: 
                        <span className={`text-weight-bold ${tablesAreCreates.length === validTables.length ? "success" : "error"}`}>
                            {tablesAreCreates.length === validTables.length ? "completed" : "issue"}
                        </span>
                    </p>
                    <p>{t("common:reset.howReset")}</p>
                    <button onClick={() => setEnableSendResetCode(true)} className="button-zone mar-10 error-bg">{t("action:reset")}</button>
                    <button onClick={restore} className="button-zone mar-10 success-bg">{t("action:restore")}</button>
                </div>
                <p className="error text-weight-bold">
                    {t("common:reset.warning")}
                </p>
            </div>
        </div>
    )
}